import Widgets from './extend/Widgets';
import Widget from './components/Widget';

export default {
  'extensions/fof-forum-widgets-core/common/extend/Widgets': Widgets,
  'extensions/fof-forum-widgets-core/common/components/Widget': Widget,
};
